import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// Session hydration (GET /auth/me) is kicked off exactly once, by the APP_INITIALIZER
// in app.config.ts (AuthService.loadUser()), before the router starts navigating.
// Do NOT also call it here: an earlier version of this component duplicated the call
// in ngOnInit, which fired two near-simultaneous /auth/me requests on every page load —
// harmless once authenticated, but on a cold load (no valid access token yet) both
// requests 401 before the auth interceptor's refresh-and-retry completes, doubling the
// console/error-tracking noise for no benefit.
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '<router-outlet></router-outlet>'
})
export class AppComponent {
}
